import { t } from '@/plugins/i18n';

const formatPrice = function (price) {
  let str = price.toString();
  let arr = str.split('').reverse();

  let len = arr.length;
  let commas = Math.floor(len / 3);

  for (let i = 0; i < commas; i++) {
    let idx = 3 * (i + 1) + i;
    if (idx >= arr.length) break;
    arr.splice(idx, 0, ',');
  }

  return `￥${arr.reverse().join('')}`;
};

const formatTime = function (seconds) {
  const pMinute = 60;
  const pHour = pMinute * 60;

  const hours = Math.floor(seconds / pHour);
  seconds = seconds - hours * pHour;
  const minutes = Math.floor(seconds / pMinute);
  seconds = Math.floor(seconds - minutes * pMinute);

  return `${hours > 0 ? hours + t('時間') : ''}${minutes > 0 ? minutes + t('分') : ''}${seconds}${t('秒')}`;
};

export {
  formatPrice,
  formatTime
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/Formatter.js